<template>
    <div class="platform-info-edit-wrp ft-12">
        <el-form class="form" :model="value" :rules="rules" ref="form" label-width="12%">
            <slot name="errMsg"></slot>
            <section>
                <div class="title ft-12">
                    <span>基础信息</span>
                </div>
                <div class="conf">
                    <el-form-item label="商品分类:" prop="categoryIds">
                       <div class="category ft-12">
                            <category-input ref="categoryInput" @fxgRecommendId-update="handleFxgRecommendIdUpdate" v-model="value.categoryIds" :isSupportAi="true" :hideEditBtn="hideEditBtn" :platform="platform" :baseItemId="baseItemId" @change="categoryIdsChange" @nameChange="categoryNamesChange" @setShopCache="setShopCache"/>
                       </div>
                    </el-form-item>
                    <el-form-item label="商品标题" prop="name">
                        <div v-if="isHasNameFix" style="margin-bottom: 8px;">
                            <el-input type="text" v-model="value.namePrefix" maxlength="50" disabled width="150px" />
                            <el-button type="link" @click="getFxgProductNameFix()">获取推荐前缀</el-button>
                            <el-button type="link" style="margin-left:-10px;" @click="clearFxgProductNameFix()">清空推荐前缀</el-button>
                            <span class="tips" style="padding-left: 12px">时尚饰品类商品，支持录入商品名称前缀，可获取平台类目推荐商品名称前缀</span>
                        </div>
                        <el-input type="text" placeholder="请输入" v-model.trim="value.name" maxlength="60" @blur="handleNameBlur" >
                            <span slot="suffix" style="margin-right: 6px;">{{ textLength(value.name) }}/60</span>
                        </el-input>
                        <div class="el-form-item__error" v-if="titleValidResult">{{ titleValidResult }}</div>
                        <p class="tips ft-12">不允许在商品标题中加入与主商品无关词，类目错放易导致平台处罚清退风险</p>
                    </el-form-item>
                    <el-form-item label="导购短标题" prop="shortTitle">
                        <el-input v-model="value.shortTitle" placeholder="建议填写简明准确的标题内容，避免重复表达">
                          <span slot="suffix" style="margin-right: 6px;">{{ textLength(value.shortTitle) }}/24</span>
                        </el-input>
                        <p class="tips ft-12">
                            短标题可用于商品搜索、首页推荐、物流单等场景，请提炼商品关键信息，客观准确填写
                            <a href="https://school.jinritemai.com/doudian/web/article/aHUW2MCvHqF3">点击了解</a>
                        </p>
                    </el-form-item>
                    <el-form-item v-if="value.categoryIds && value.categoryIds.length" label="品牌" prop="shopBrandConf">
                        <BrandIdBlock
                            ref="BrandIdBlockRef"
                            v-model="value.shopBrandConf"
                            :shopList="fxgAndGxShopList" 
                            :baseItemId="baseItemId"
                            :categoryId="categoryId"
                            />
                    </el-form-item>
                    <el-form-item label="推荐语" prop="recommendRemark">
                        <el-input
                            type="text"
                            placeholder="请输入，限8～50个汉字"
                            v-model="value.recommendRemark"
                            maxlength="50"
                            show-word-limit
                            >
                        </el-input>
                    </el-form-item>
                    <el-form-item label="类目属性">
                        <UseCategoryTemplate 
                            :detailHasCategory="detailHasCategory" 
                            :detailId="value.id" :baseItemId="baseItemId" 
                            :categoryIds="value.categoryIds" 
                            :platform="platform" :propValues="value.productFormat" 
                            :fxgCategoryPropertyPics="value.categoryPropertyPics"
                            @clickFill="clickTemPlateFill"
                        >
                            <CategoryAttr 
                                v-model="value.categoryAttrValue" 
                                :initAttrData="initAttrData" 
                                :initMeasureData="initMeasureData" 
                                :baseItemId="baseItemId" 
                                :categoryIds="value.categoryIds" 
                                :self_form="value"
                                :namePrefix="value.namePrefix" 
                                :getPrefix="getFxgProductNameFix" 
                                ref="cateprops"
                                @changePropertyPics="changePropertyPics"
                                @refundRuleChange="handleRefundRuleChange" 
                                @select-changed="handleCategoryValueChanged" 
                                @oneClickFill="oneClickFill"
                                @fetchAttrs="getCategoryProperties"
                            />
                        </UseCategoryTemplate>
                    </el-form-item>
                    <el-form-item v-if="!!digitalIDList.length" prop="digitalID">
                        <template slot="label">
                            <div><span style="color: red;">*</span>产品数字身份证</div>
                            <el-link href="http://www.gs1cn.org" target="_blank" :underline="false">如何获取</el-link>
                        </template>
                        <DigitalID 
                            ref="digitalIDRef" 
                            v-model="value.digitalIDAttrValue"
                            :initAttrData="initAttrData" 
                            :digitalIDList="digitalIDList" 
                            :categoryAttrList="categoryAttrList" 
                            :initMeasureData="initMeasureData" 
                            :baseItemId="baseItemId" 
                            :categoryIds="value.categoryIds" 
                            :namePrefix="value.namePrefix" 
                            :getPrefix="getFxgProductNameFix" 
                            @refundRuleChange="handleRefundRuleChange" 
                            @select-changed="handleCategoryValueChanged" 
                        />
                    </el-form-item>
                    <el-form-item label="尺码信息：" prop="sizeType">
                        <el-radio-group v-model="value.sizeType">
                            <el-radio :label="3">店铺尺码表</el-radio>
                            <el-radio :label="1">商品尺码表</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="value.sizeType == 3" label="店铺尺码表：" prop="sizeTemplateConf">
                        <ShopSizeListVue
                            ref="shopSizeRef"
                            :shopList="fxgAndGxShopList"
                            v-model="value.sizeTemplateConf"
                            :specifications="specifications"
                            :componentTemplateRule="componentTemplateRule"
                            @editShopSize="payload => openShopSize(payload, 'edit')"
                        />
                    </el-form-item>
                    <el-form-item v-else-if="value.sizeType == 1" label="商品尺码表：" prop="sizeTemplateList">
                        <!-- <el-row>
                            <el-col v-if="value.sizeTemplateList && value.sizeTemplateList.length">
                                <span style="font-size: 12px">已添加尺码信息</span>
                                <el-button type="link" @click="showAddSize(true,'editSize')">预览/编辑</el-button>
                                <el-button type="link" @click="delSize">删除</el-button>
                            </el-col>
                            <el-col v-else>
                                <el-button @click="showAddSize(false,'add')">添加尺码</el-button>
                                <span class="tips" style="padding-left: 12px">尺码模板请在抖店后台中提前维护，快麦通支持编辑选择</span>
                            </el-col>
                        </el-row> -->
                        <!-- 添加尺码信息弹窗 -->
                        <AddSize v-if="componentTemplateRule" ref="addSizeRef" :shopList="fxgAndGxShopList" :templateList='value.sizeTemplateList' :specifications="specifications" :categoryId="categoryId" :showGenerateBtn="true" :componentTemplateRule="componentTemplateRule" @validSize="getErrorCount"/>
                    </el-form-item>
                     <el-form-item label="尺码图：" prop="sizePicUrl">
                        <ImgUpload
                            ref="sizePicUrl"
                            :limitWidth="[0, 5000]"
                            :limitHeight="[0, 20000]"
                            :limitSize="5 * 1024 * 1024"
                            limitSuffix=".jpg,.jpeg,.png" 
                            :file="value.sizePicUrl"
                            :isSingle="true"
                            @upload-success="url => onSizePicUrlChange(url)"
                            @del="() => onSizePicUrlChange('')"
                        />
                            <p class="tips ft-12">
                            1.上传的尺码图默认放在详情图的最后一张；<br />
                            2.仅支持png，jpg，jpeg格式；单张尺码图宽高比不超过5000*20000px，大小5M以内；<br />
                            3.支持最多传图1张。
                        </p>
                    </el-form-item>
                </div>
            </section>
            <section>
                <div class="title">
                    <span>图文信息</span>
                </div>
                <div class="conf">
                    <el-form-item label="引用套图:" v-if="showGroupImages">
                        <div class="ft-12">商品资料已维护套图，电商平台图片可以使用已维护套图快速填充 <el-link @click="editGroupImages">维护套图</el-link> </div>
                        <GroupImagesList :baseItemId="baseItemId" :specifications="specifications" @useOk="useGroupImages" @getList="getGroupImagesList"></GroupImagesList>
                    </el-form-item>
                    <el-form-item label="主图:" prop="pic" style="margin-bottom: 0px;">
                        <div class="imgs-wrp">
                            <div class="ft-12">展示时只取主图，拖动可调整顺序 <BatchEditImages v-model="value.pic" refName="pic" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
                            <MutiImgUpload
                                v-model="value.pic"
                                ref="pic"
                                :key="JSON.stringify(autoCropImageConfigList)"
                                limitSuffix=".jpg,.jpeg,.png,.webp" 
                                :limitNums="5"
                                :limitWidth="isCheckMainImg ? [600,0]:[0, 0]"
                                :limitHeight="isCheckMainImg ? [600,0]:[0, 0]"
                                :limitSize="isCheckMainImg ? 5 * 1024 * 1024 : 0"
                                :size="200"
                                :aspectRatio="isCheckMainImg ? 1 :0"
                                :aspectRatioText="isCheckMainImg ? '1:1' : ''"
                                show-audit-result
                                :auditFileList="auditFileList"
                                :autoCropImageParams="{publishAutoCropImageEnum:'FXG_MainImg11'}"
                                :supportAiRetry="true"
                            />
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <p class="tips ft-12">
                            1.主图至少3张图片，至多5张图片，主图图片应包含商品正反面外包装图，若涉及活动，图片上需清晰体现活动时间和活动方式，需审核通过后生效。<br />
                            2.仅支持png，jpg，jpeg格式；建议上传1:1的图片，图片至少600*600，图片大小不超过5M。<br />
                        </p>
                    </el-form-item>
                    <el-form-item label="主图3:4:" prop="mainImages34" style="margin-bottom: 0px;">
                        <template slot="label">
                            主图3:4
                            <el-tooltip effect="dark" content="3:4主图将在商详及商城猜你喜欢场景露出展示，预估最高可提升3%商品点击率，有机会获得更多流量提升转化。" placement="top-start">
                                <i style="font-size: 14px;" class="el-icon-Group-14"></i>
                            </el-tooltip>
                        </template>
                        <div><BatchEditImages v-model="value.mainImages34" refName="mainImages34" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
                        <div class="imgs-wrp">
                            <MutiImgUpload
                                v-model="value.mainImages34"
                                ref="mainImages34"
                                :key="JSON.stringify(autoCropImageConfigList)"
                                :mainImgNums="0" 
                                limitSuffix=".jpg,.jpeg,.png"
                                :limitNums="5"
                                :limitWidth="isCheckMainImg34 ? [375, 0] : [0,0]"
                                :limitHeight="isCheckMainImg34 ? [500, 0] : [0,0]"
                                :limitSize="isCheckMainImg34 ? 5 * 1024 * 1024 : 0"
                                :aspectRatio="isCheckMainImg34 ? [0.75] : 0"
                                :cropDefaultSize="[750, 1000]"
                                :aspectRatioText="isCheckMainImg34 ? '3:4' : ''"
                                :size="200"
                                show-audit-result
                                :auditFileList="auditFileList"
                                :autoCropImageParams="{publishAutoCropImageEnum:'FXG_MainImg34'}"
                            />
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <p class="tips ft-12">
                            仅支持png，jpg，jpeg格式，图片宽高不低于375*500（750*1000最佳），大小5M内。
                            <a href="https://school.jinritemai.com/doudian/web/article/aHKu33ExA3nV?rank=0" target="_blank">点击详情</a>
                        </p>
                    </el-form-item>
                    <!-- <el-form-item label="3:4导购图:" prop="guideImg" style="margin-bottom: 0px;">
                        <div class="imgs-wrp">
                            <MutiImgUpload
                                v-model="value.guideImg"
                                ref="guideImg"
                                :key="JSON.stringify(autoCropImageConfigList)"
                                :mainImgNums="0" 
                                :limitNums="1"
                                :limitWidth="isCheckGuideImg ? [375, 0] : [0,0]"
                                :limitHeight="isCheckGuideImg ? [500, 0] : [0,0]"
                                :limitSize="isCheckGuideImg ? 5 * 1024 * 1024 : 0"
                                :aspectRatio="isCheckGuideImg ? [0.75] : 0"
                                :cropDefaultSize="[750, 1000]"
                                :aspectRatioText="isCheckGuideImg ? '3:4':''"
                                :size="200"
                                show-audit-result
                                :auditFileList="auditFileList"
                                :autoCropImageParams="{publishAutoCropImageEnum:'FXG_MainImg34'}"
                            />
                        </div>
                    </el-form-item> -->
                    <el-form-item>
                        <p class="tips ft-12">
                            1. 图片宽高≥375*500，建议使用750*1000，大小不超过5M，更多规则可查看<a href="https://school.jinritemai.com/doudian/web/article/aHKu33ExA3nV">更多详情</a><br />
                            2. 建议上传实拍真人模特图或全貌商品图，背景颜色切勿花哨、勿用衣架和假体模特做表达
                        </p>
                    </el-form-item>
                    <el-form-item label="白底图:" prop="dialogImageUrl" style="margin-bottom: 0px;">
                        <MutiImgUpload 
                            v-model="dialogImageUrl" 
                            ref="bg_MutiImgUpload"
                            :key="JSON.stringify(autoCropImageConfigList)"
                            :mainImgNums="0" 
                            :limitWidth="isCheckWhiteImg ? [600, 0] : [0,0]" 
                            :limitHeight="isCheckWhiteImg ? [600, 0] : [0,0]" 
                            :limitSize="isCheckWhiteImg ? 5 * 1024 * 1024 : 0" 
                            :size="200"
                            limitSuffix=".jpg,.jpeg,.png" 
                            :limitNums="1"
                            :aspectRatio="isCheckWhiteImg ? 1 : 0"
                            :aspectRatioText="isCheckWhiteImg ? '1:1' : ''"
                            :isSquare="isCheckWhiteImg"
                            :isSingle="true"
                            :autoCropImageParams="{publishAutoCropImageEnum:'FXG_WhiteImg'}"
                        />
                    </el-form-item>
                    <el-form-item>
                        <p class="tips ft-12">
                            1. 上传清晰白底图，有助于在抖音商城内获得更多推荐流量！<br />
                            2. 白底图需大于等于600*600，比例要求1:1，支持jpg/jpeg/png格式，大小需小于5M；纯白背景，无牛皮癣、logo、阴影等；主体完整不变形、居中展示，有效像素宽或高不小于70%<br />
                        </p>
                    </el-form-item>
                    <el-form-item label="商品详情图:" prop="description" style="margin-bottom: 0px;">
                        <div><BatchEditImages v-model="value.description" refName="description_MutiImgUpload" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
                        <div class="imgs-wrp">
                            <MutiImgUpload 
                                v-model="value.description" 
                                ref="description_MutiImgUpload"
                                :key="JSON.stringify(autoCropImageConfigList)"
                                :mainImgNums="0" 
                                :limitWidth="isCheckDesc ? [0, 5000] : [0,0]" 
                                :limitHeight="isCheckDesc ? [0, 20000] : [0,0]" 
                                :size="200"
                                :limitSize="isCheckDesc ? 5 * 1024 * 1024 : 0" 
                                limitSuffix=".jpg,.jpeg,.png" 
                                :limitNums="50"
                                :needAutoCrop="true"
                                show-audit-result
                                :auditFileList="auditFileList"
                                :autoCropImageParams="{publishAutoCropImageEnum:'FXG_Desc'}"
                                :supportAiRetry="true"
                            />
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <p class="tips ft-12">
                            1. 详情图图片应与商品相关，包含商品正反面外包装图，若涉及活动，图片上需清晰体现活动时间，活动方式。<br />
                            2. 若商品为食品，反面外包装图还需清晰体现SC码，以及生产厂商、生产日期、有效期等详细信息。<br />
                            3. 商品详情将在用户端商品详情页展示，请注意内容与商品相关且不宜过长，需审核通过后生效。<br />
                            4. 最多上传50张，仅支持png，jpg，jpeg格式；单张详情图宽高比不超过5000*20000px，大小5M内。
                        </p>
                    </el-form-item>
                    <el-form-item label="商品视频" class="form-field-videoInfo">
                        <div class="imgs-wrp">
                            <!-- 视频组件 -->
                            <el-row style="display: flex; align-items: center;">
                                <VideoUpload style="text-align: left;" @upload-success="videoUploadSuccess" :video="value.videoInfo && value.videoInfo[0]" aspectRatio="1:1,3:4,9:16" limitSuffix=".mp4" :limitWidth="[600, 0]" :limitHeight="[600, 0]" @del="videoDel" :limitDuration="60" :companyId="userInfo.companyId"/>
                            </el-row>
                            <div class="tips ft-12">
                                <span>1. 仅支持mp4格式上传，大小100M内，比例支持1:1、3:4及9:16比例视频（最少宽高600x600）。<a href="https://school.jinritemai.com/doudian/web/article/113410?from=shop_default" target="_blank">点击了解</a></span>
                                <span>2.{{`​时长<=60s，建议30秒内短视频最佳（可优先在商品等推荐频道展现）`}}。</span>
                            </div>
                        </div>
                    </el-form-item>
                </div>
            </section>
            <section>
                <div class="title">
                    <span>价格库存</span>
                </div>
                <div class="conf">
                    <el-form-item label="发货模式:" prop="presellType">
                        <el-radio-group v-model="value.presellType">
                            <el-radio v-for="item in deliveryModes" :label="item.value" :value="item.value" :key="item.value" style="margin-right: 15px;"> {{item.label}}
                                <el-tooltip effect="dark" v-if="item.value === 3" content="若存在店铺不支持现货+预售发货模式，铺货时默认按照现货模式及配置的现货发货时效进行铺货，若未配置现货时效，默认取48小时内发货。">
                                    <i style="font-size: 14px;" class="el-icon-Group-14"></i>
                                </el-tooltip>
                                <el-tooltip  v-if="item.value === 2" class="item" effect="dark" content='(新)现货+预售发货模式下，不支持仅预售，若未选择现货发货时效，默认48小时内发货，库存取规格明细中现货库存；若存在店铺需调整现货发货时效，请在执行铺货时前往“确认发布信息"中调整发货模式' placement="top">
                                    <i style="font-size: 14px;" class="el-icon-question" />
                                </el-tooltip>
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="现货发货时间:" v-if="value.presellType === 0 || value.presellType === 2" prop="deliveryDelayDay">
                        <div class="delivery-time">
                            <!-- 现货+预售发货模式使用checkbox -->
                            <el-checkbox-group @change="handleDeliveryDelayDayChange" v-if="value.presellType === 2" v-model="value.deliveryDelayDay" class="deliveryDelayDay">
                                <el-checkbox v-for="item in normalDelayOptions" :label="item.value" :key="item.value">{{item.label}}</el-checkbox>
                            </el-checkbox-group>
                            <!-- 现货发货模式使用radio -->
                            <el-radio-group v-else v-model="value.deliveryDelayDay" class="deliveryDelayDay">
                                <el-radio v-for="item in normalDelayOptions" :label="item.value" :value="item.value" :key="item.value">{{item.label}}</el-radio>
                            </el-radio-group>
                        </div>
                    </el-form-item>
                    <!-- 全款预售配置 -->
                    <template v-if="value.presellType === 1">
                        <el-form-item label="预售结束时间:" prop="presellEndTime">
                            <div class="presell-end-time">
                                <div class="radio-item">
                                    <el-radio v-model="value.presellEndTimeType" :label="1">设置结束时间</el-radio>
                                    <el-date-picker
                                        v-if="value.presellEndTimeType === 1"
                                        v-model="value.presellEndTime"
                                        type="datetime"
                                        placeholder="请选择结束时间"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        style="width: 220px; margin-left: 10px"
                                    ></el-date-picker>
                                </div>
                                <div class="radio-item" style="margin-top: 10px">
                                    <el-radio v-model="value.presellEndTimeType" :label="2">无结束时间</el-radio>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item class="tips">
                            预售期间产生的订单须以预售发货时间进行发货；预售结束后，商品将自动下架
                            <br/>
                            最多支持设置距离当前为30天
                        </el-form-item>

                        <el-form-item label="预售发货时间:" prop="presellDeliveryType">
                            <div class="presell-delivery-time">
                                <el-select 
                                    v-model="value.presellDeliveryType"
                                    placeholder="请选择发货时间"
                                    style="width: 160px"
                                >
                                <el-option 
                                    v-for="item in allSaveDeliveryMode"
                                    :key="item.value"
                                    :label="item.label" 
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                                <div class="delivery-days" style="display: inline-block; margin-left: 10px">
                                    <el-input-number 
                                        v-model="value.presellDelay"
                                        :min="deliveryRules.minDays"
                                        :max="deliveryRules.maxDays"
                                        :precision="0"
                                        :step="1"
                                        style="width: 120px"
                                    ></el-input-number>
                                    <span class="tips" style="margin-left: 10px">天内发货</span>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item  class="tips">
                            预售期间产生的订单须以预售发货时间进行发货；预售结束后，商品将自动下架
                            <br/>
                            预售期间商品发货时间以此限制为主，仅可设3 - 30天
                        </el-form-item>
                    </template>
                    <el-form-item label="预售发货时间:" v-if="value.presellType === 2" prop="timeSpecList">
                        <div class="presale-wrp" style="padding-bottom: 16px">
                            <el-checkbox-group v-model="value.timeSpecList">
                                <el-checkbox
                                    v-for="item in timeSpecLabels"
                                    :key="item.timeType"
                                    :label="item.timeType"
                                    > {{ item.timeDesc }}</el-checkbox>
                            </el-checkbox-group>
                            <p style="margin-bottom: 0">发货时效计算起点：买家支付后开始计算发货时效（例：买家支付后5天发货）</p>
                        </div>
                    </el-form-item>
                    <el-form-item label="商品规格:" prop="skuAttrs">
                        <RuleSortBtn :specifications.sync="specifications" />
                        <SpecsValuesSort :specifications.sync="specifications" />
                        <DdianSpecification
                            ref="fxgSpecification"
                            v-model="specifications"
                            remarkKey="note"
                            :supportPropertyDiy="supportPropertyDiy"
                            :ruleParams="fxgProductUpdateRuleParams"
                            :unrenderSpecList="unrenderSpecList"
                            :needlessSpecList="needlessSpecList"
                            :requiredSpecDetails="requiredSpecDetails"
                            :maxSpecNumLimit="maxSpecNumLimit"
                            :specSingleLimit="specSingleLimit"
                            :changeToBase="changeToBase"
                            :show-audit-result="true"
                            :auditFileList="auditFileList"
                            @fieldChanged="specificationsFieldChanged"
                            :platform="platform"
                            :isCheckImg="isCheckSkuImg"
                        />
                    </el-form-item>
                    <el-form-item label="规格明细:" prop="skuAttrsDetail">
                        <p
                            v-if="openSource !== 'shopGoods'"
                            class="tips-wrap"
                            style="margin: 0; color: #aaa; font-size: 12px;"
                        >规格信息与基础资料不一致时，需手动绑定商家编码，请点击「批量绑定商家编码」或下方SKU列表中「商家编码输入框」进行绑定操作；</p>
                        <FormItemSkuList
                            :specifications="specifications"
                            :tableCols="skuTableCols"
                            :baseItemId="baseItemId"
                            :showBindSkuOuterId="openSource !== 'shopGoods'"
                            :outerProductId="value.outerProductId"
                            skuOuterIdKey="code"
                            v-model="skuList"
                            multipleSelection
                            @fieldChanged="specificationsFieldChanged"
                            @selection-change="handleSkuSelectionChanged"
                        >
                            <template slot="skuPictureHeaderSlot" slot-scope="{ col }">
                                <span>{{col.attrs.label}}<span style="color:red;" v-if="skuPictureRule.requireType == 1">*</span></span>
                            </template>
                            <template slot="skuPictureSlot" slot-scope="{ row,$index }">
                                <div>
                                    <ImgUpload
                                        :ref="`skuPicture_${$index}`"
                                        :width="60"
                                        :height="60"
                                        :limitWidth="[0,0]"
                                        :limitHeight="[0,0]"
                                        :aspectRatio="isCheckSkuPicture ? 1 : 0"
                                        aspectRatioText="isCheckSkuPicture ? 1:1 : ''"
                                        :limitSize="isCheckSkuPicture ? 5 * 1024 * 1024 : 0"
                                        limitSuffix=".jpg,.jpeg,.png"
                                        :isSingle="true"
                                        :file="row.skuPictureUrl"
                                        @upload-success="(url) => handleSkuPictureUpload(row, url, $index)"
                                        @del="() => handleSkuPictureDel(row, $index)"
                                        @handleLoad="() => handleSkuPictureLoaded(row, $index)"
                                    />
                                    <div style="color: red;white-space: normal;" class="el-form-item__error" v-if="row.skuPictureErrMsg">{{ row.skuPictureErrMsg }}</div>
                                </div>
                            </template>
                            <template slot="skuStatusSlot" slot-scope="{ row,$index }">
                                <el-switch v-model="row.skuStatus"></el-switch>
                            </template>
                            <template slot="skuBatchSlot">
                                <el-button style="margin-left:5px;" @click="batchSetSKUImgVisible = true">批量设置SKU图</el-button>
                            </template>
                        </FormItemSkuList>
                        <template v-if="specificationsValidResult !== true">
                            <div class="el-form-item__error">{{specificationsValidResult}}</div>
                        </template>
                    </el-form-item>
                     <el-form-item label="售卖价:" prop="discountPrice">
                        <div class="price-wrp">
                            <span>¥</span>
                            <el-input
                                type="text"
                                placeholder="必须大于0，最多保留两位小数"
                                v-model="discountPrice"
                                width="250px"
                                disabled
                                >
                                <template
                                    slot="suffix"
                                >
                                    <span class="suffix">元</span>
                                </template>
                            </el-input>
                            <div class="tips ft-12">
                                <span>请依据公平、合法和诚实信用原则及市场规律进行价格填写。当商品参与促销活动时，该价格可能会作为促销基准价（展示形式包括“参考价”、“划线价”等）共消费者参考，请谨慎填写，避免出现价格欺诈等违法违规情形。</span>
                            </div>
                        </div>
                    </el-form-item>
                    <template v-if="referencePriceRule.isSupport">
                        <el-form-item label="参考价:" prop="referencePrice">
                            <div class="price-wrp">
                                <el-input-digit
                                    type="text"
                                    placeholder="参考价"
                                    v-model.number="value.referencePrice"
                                    style="width: 250px;"
                                >
                                    <span class="suffix">元</span>
                                </el-input-digit>
                                <div class="tips ft-12">
                                    <span>请确保录入的价格真实有效并与价格凭证保持一致。若价格录入错误或上传虚假凭证，您将面临价格欺诈等法律风险。当前参考价的主要场景为直播间讲解展示使用，未来将应用来商品详情，搜索等场景。</span>
                                </div>
                            </div>
                        </el-form-item>
                        <template v-if="value.referencePrice">
                            <el-form-item label="参考价凭证类型:" prop="referencePriceCertificate.certificate_type">
                                <div class="price-wrp">
                                    <el-select
                                        placeholder="请选择凭证类型"
                                        v-model="value.referencePriceCertificate.certificate_type"
                                        width="250px"
                                    >
                                        <template v-for="(item, index) in certificateTypeEnum">
                                            <el-option :key="index" :label="item.label" :value="item.value" />
                                        </template>
                                    </el-select>
                                </div>
                            </el-form-item>
                            <el-form-item label="参考价凭证图:" prop="referencePriceCertificate.certificate_urls">
                                <div class="imgs-wrp">
                                    <MutiImgUpload
                                        v-model="value.referencePriceCertificate.certificate_urls"
                                        ref="certificate_urls"
                                        :mainImgNums="0" 
                                        :limitNums="1"
                                        :limitSize="5 * 1024 * 1024"
                                        limitSuffix=".jpg,.jpeg,.png"
                                        :isSingle="true"
                                        show-audit-result
                                        :auditFileList="auditFileList"
                                    />
                                    
                                </div>
                            </el-form-item>
                            <el-form-item>
                                <p class="tips ft-12">
                                    请确保上传真实、有效、清晰的价格凭证，并与所选的“参考价”类型保持一致，避免出现价格欺诈等违规情形。详情请<el-link target="_blank" style="vertical-align: top;" href="https://school.jinritemai.com/doudian/web/article/aHZFkJ3amwW6?from=shop_default">点击了解</el-link><br />
                                    仅支持png，jpg，jpeg格式；大小5M内<br />
                                </p>
                            </el-form-item>
                        </template>
                    </template>
                     <el-form-item label="重量(kg):" prop="weight">
                        <el-input
                            type="text"
                            placeholder="请输入重量"
                            v-model="value.weight"
                            width="250px"
                            >
                        </el-input>
                    </el-form-item>
                </div>
            </section>
            <section>
                <div class="title">
                    <span>服务与资质</span>
                </div>
                <div class="conf">
                    <el-form-item label="支付方式:" prop="payType">
                        <el-radio-group v-model="value.payType">
                            <el-radio v-for="item in payWayModes" :label="item.value" :key="item.value">{{item.label}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="库存计数:" prop="reduceType">
                        <el-radio-group v-model="value.reduceType">
                            <el-radio v-for="item in reduceModes" :label="item.value" :key="item.value">{{item.label}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="商品限购:">
                        <table class="goodsLimitTable" border="1" cellspacing="0" cellpadding="5" bordercolor="#ebebeb">
                            <thead>
                                <th>单用户累计限购（件）</th>
                                <th>单用户每次限购（件）</th>
                                <th>单用户每次至少购买（件）</th>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style="height: 55px; padding-bottom: 15px">
                                        <el-form-item prop="limitPerBuyer">
                                            <el-input v-model="value.limitPerBuyer"></el-input>
                                        </el-form-item>
                                    </td>
                                    <td style="height: 55px; padding-bottom: 15px">
                                        <el-form-item prop="maximumPerOrder">
                                            <el-input v-model="value.maximumPerOrder"></el-input>
                                        </el-form-item>
                                    </td>
                                    <td style="height: 55px; padding-bottom: 15px">
                                        <el-form-item prop="minimumPerOrder">
                                            <el-input v-model="value.minimumPerOrder"></el-input>
                                        </el-form-item>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </el-form-item>
                    <el-form-item v-if="shippingOriginRule.enable" label="发货地:" prop="shippingOriginInfo" :rules="shippingOriginInfoRules">
                        <el-radio-group v-model="value.shippingOriginInfo.shippingOriginType" @change="handleShippingOriginTypeChange">
                            <el-radio v-for="item in shippingOriginRule.options" :key="item.value" :label="item.value">{{ item.name }}</el-radio>
                        </el-radio-group>
                        <div style="margin-top: 10px">
                        <el-select
                            v-model="value.shippingOriginInfo.shippingOriginId"
                            placeholder="请选择发货地"
                            style="width: 100%"
                            @change="handleShippingOriginChange"
                        >
                            <el-option
                            v-for="item in shippingOriginOptions"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value"
                            />
                        </el-select>
                        </div>
                    </el-form-item>
                    <el-form-item label="无理由退货服务:" prop="supplyDayReturnSelector">
                        <el-select v-model="value.supplyDayReturnSelector" placeholder="请选择" width="300px">
                            <el-option v-for="item in supplyDayReturnList" :key="item.value" :label="item.name" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <template v-if="threeGuarantees.enable"> 
                        <el-form-item label="售后服务承诺:" prop="threeGuarantees.serviceType" :rules="[{required: threeGuarantees.mustSelect, message: '请选择三包服务承诺'}]">
                            <el-radio-group v-model="value.threeGuarantees.serviceType">
                                <el-radio v-for="item in threeGuarantees.options" :key="item.value" :label="item.value+''">{{item.name}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="选择保修天数:" prop="threeGuarantees.duration" :rules="[{required: threeGuarantees.mustSelect, message: '请选择三包服务承诺'}]">
                            <el-select v-model="value.threeGuarantees.duration" placeholder="请选择" width="300px">
                                <el-option v-for="item in threeGuaranteesDurationOptions" :key="item.value" :label="item.name" :value="item.value+''">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                    <el-form-item label="客服电话:" prop="mobile">
                        <el-input
                            type="text"
                            placeholder="仅支持录入手机号码，座机号及400-800电话"
                            v-model="value.mobile"
                            maxlength="32"
                            show-word-limit
                            >
                        </el-input>
                        <div class="tips">
                            <span style="color:blue;cursor: pointer;" @click="getTelephoneConf">
                              客服电话设置
                            </span>
                        </div>
                    </el-form-item>
                    <el-form-item label="安装模式:" prop="homeInstallServiceTemplateId" v-if="homeInstallServiceRule.options && homeInstallServiceRule.options.length">
                        <el-select v-model="value.homeInstallServiceTemplateId" placeholder="请选择安装模式">
                            <el-option-group v-for="group in homeInstallServiceRule.options" :key="group.name" :label="group.name">
                                <el-option v-for="item in group.options" :key="item.value" :label="item.name || '无'" :value="item.value"></el-option>
                            </el-option-group>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        :label="`${item.qualityName}：`"
                        :prop="`qualityKey${index+1}`"
                        v-for="(item, index) in qualityList"
                        :key="item.qualityKey"
                    >
                        <div><BatchEditImages v-model="item.images" :refName="`quality_imgs_${index}`" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
                        <div class="img-and-tips">
                            <MutiImgUpload
                                :ref="`quality_imgs_${index}`"
                                v-model="item.images" 
                                :mainImgNums="0"
                                :limitNums="20"  show-audit-result
                                :auditFileList="auditFileList" />
                            <div class="tips">
                                <span
                                    v-for="text in item.textList"
                                    :key="text"
                                >
                                    {{ text }}
                                </span>
                            </div>
                        </div>
                    </el-form-item>
                </div>
            </section>
             <!-- 运费模板 -->
              <section>
                <div class="title ft-12">
                  <span>运费模板</span>
                </div>
                <div class="conf">
                  <el-form-item label="运费设置：">
                    <el-row v-if="fxgAndGxShopList.length > 0">
                      <el-col v-for="shop in fxgAndGxShopList" :key="shop.id" :span="12" class="set-ship">
                        <el-image
                        :src="shop.icon"
                        style="height: 18px; margin-right:5px"
                        ></el-image>
                        <el-tooltip v-if="shop.channelIcon" :content="shop.channelName" style="margin: 0px -6px 0px 6px;">
                            <el-image :src="shop.channelIcon" style="width: 18px; height: 18px;"></el-image>
                        </el-tooltip>
                        <span class="shop-title">{{ shop.shortTitle || shop.title}}</span>
                        <el-select
                            v-if="!!shipsValue"
                            v-model="shipsValue[shop.id]"
                            :loading="selectLoading" 
                            :value-key="String(shop.id)"
                            placeholder="请选择运费模板"
                            clearable
                            filterable
                            :remote="shop.source ==='fxg'"
                            :remote-method="query => queryTemplates(query, shop)"
                            @visible-change="isVisible => changeSelect(isVisible, shop)"
                            >
                            <el-option
                                v-for="ship in shipsTemplate[shop.id]"
                                :key="ship.id"
                                :label="ship.name"
                                :value="ship.id"
                                >
                            </el-option>
                        </el-select>
                      </el-col>
                    </el-row>
                    <span v-else class="no-shops">暂无平台店铺</span>
                  </el-form-item>
                </div>
              </section>
              <!-- 上架设置 -->
              <section>
                <div class="title ft-12">
                  <span>上架设置</span>
                </div>
                <div class="conf">
                  <el-form-item 
                    label="上架设置:" 
                    :rules="[{required: true, message: '请输入上架设置', trigger: 'blur'}]">
                      <el-radio-group v-model="isOnshelf">
                          <el-radio :label="1">立即上架</el-radio>
                          <el-radio :label="2">放入草稿箱</el-radio>
                          <el-radio :label="0">下架</el-radio>
                      </el-radio-group>
                  </el-form-item>
                </div>
              </section>
              <!-- 添加尺码信息弹窗 -->
              <AddSizeDialog v-if="componentTemplateRule" ref="addSizeDialog" :sizeType="value.sizeType" :shopList="fxgAndGxShopList" @sizeTemplate='addOrUpdateSizeTemplate' :specifications="specifications" :categoryId="categoryId" :showGenerateBtn="true" :componentTemplateRule="componentTemplateRule"/>
              <BatchSetSKUImg v-model="batchSetSKUImgVisible" @confirm="batchSetSKUImg" />
        </el-form>
    </div>
</template>
<script>
import '@/assets/css/prod.scss';
import ImgUpload from '@/components/Uploads/ImgUpload.vue';
import MutiImgUpload from '@/components/Uploads/MutiImgUpload'
import BatchEditImages from '@/components/prod/center/components/BatchEditImages.vue'
import GroupImagesList from '@/components/prod/center/BasicComps/GroupImages/list.vue'
import Upload from '@/components/Uploads/ImgUpload.vue';
import VideoUpload from '@/components/Uploads/videoUpload'
import SkuTableList from '../SkuTableList.vue';
import GenSkuOuterIdDialog from '../../dialogs/GenSkuOuterIdDialog.vue'
import CategoryInput from '../PlatformCategoryInput/index.vue';
import UseCategoryTemplate from '../UseCategoryTemplate.vue'
import BatchSetSKUImg from './BatchSetSKUImg.vue';

import RULES, { getHomeInstallServiceTemplateIdRules, getSizeTypeRules, getSizeTemplateConfRules, getShippingOriginInfoRules, checkTitleValid } from './rules.js';
import { getScmCodeFxgPlat } from '@/servers/prod/center/fxg.js';
import { getBytesCount_v2 } from "@utils/data"

import {specification_mixin} from '../FormItemSpecification'
import CategoryAttr from './CategoryAttr.vue';
import AddSizeDialog from './addSizeDialog.vue';
import AddSize from './addSize.vue';
import BrandIdBlock from "./BrandIdBlock.vue";
import DigitalID from "./DigitalID.vue";
import {getDistributionConfig, getFxgTemplateList, getFxgGxTemplateList} from '@servers/prod/conf/index.js'
import { mapGetters } from "vuex"
import { fxgSearchProductQualityList,fxgSearchProductQualityList2, queryFxgNeedProductNameFix, getFxgProductNameFix, getProductUpdateRule, fxgGetCascadeValues, fxgPublishPreCheckTitle } from '@/api/prod/center';
import _, { last, get, cloneDeep } from 'lodash';
import validateMixin from '../validateMixin';
import shopListMixin from '../shopListMixin';
import { formatSubmitSpecs, gernerateFxgSpecs, parseProductFormat, skuTableCols} from './service';
import DdianSpecification from './DdianSpecification.vue';
import ProductMappingDialog from '@/components/prod/center/dialogs/ProductMappingDialog.vue';
import ShopSizeListVue from './shopSizeList.vue';

export default {
    mixins: [specification_mixin, validateMixin, shopListMixin],
    inject: {
        isGroupPuhuo: { default: false },
    },
    provide(){
        return {
            platform: "fxg",
            openSource:this.openSource
        }
    },
    components: {
        ImgUpload,
        MutiImgUpload,
        BatchEditImages,
        GroupImagesList,
        Upload,
        VideoUpload,
        SkuTableList,
        CategoryInput,
        CategoryAttr,
        BrandIdBlock,
        AddSize,
        AddSizeDialog,
        DdianSpecification,
        GenSkuOuterIdDialog,
        ProductMappingDialog,
        ShopSizeListVue,
        UseCategoryTemplate,
        DigitalID,
        BatchSetSKUImg,
    },
    props: {
        formData: {
            type: Object,
            default() {
                return {};
            }
        },
        shopsList: {
            type: Array,
            default: ()=> {
                return []
            }
        },
        changeToBase: Function,
        baseItemId: [Number, String],
        rowData: {
            type: Object,
            default: () => ({})
        },
        openSource:{
            type:String,
            default:''
        },
    },
    data() {
        return {
            throttledHandleName: null, // 用于存放节流函数
            dialogType:'add',
            shopSizeListData:[],
            resSizeTemplateConf:[],
            previewTemplateInfo:{},
            isFxg: true,
            hideEditBtn:false,
            platform: 'fxg',
            needValiSymbol: true, // 校验规格名规格值非法字符
            initAttrData: {},
            initMeasureData: {},
            mixinsFormKey: 'value',
            showGroupImages: true,
            value: {
                namePrefix: '',  // 商品标题前缀
                name: '', // 商品标题
                recommendRemark: '',// 推荐语
                categoryIds: [],  // 商品分类
                brandId: '', // 品牌
                pic: [],
                mainImages34: [],
                description: [],
                presellType: 0, // 发货模式
                presellDeliveryType: 1,
                deliveryDelayDay: 9999, // 承诺发货时间
                presellEndTime: '', // 预售结束时间
                presellDelay: 1, // 预售发货时间
                presellDelay: 1, // 阶梯发货模式发货时间
                payWay: 1, // 支付方式
                reduceType: 1, // 库存计数
                limitPerBuyer: '', // 单用户累计限购（件）
                maximumPerOrder: '', // 单用户每次限购（件）
                minimumPerOrder: '', // 单用户每次至少购买（件）
                supplyDayReturnSelector: '', // 是否支持7天无理由
                referencePrice: '', //参考价
                referencePriceCertificate: {
                    certificate_type: '',
                    certificate_urls: [],
                },
                videoInfo: [null],
                weight: '', // 重量
                mobile: '', // 客服电话
                qualityKey1: [], // 报关单
                qualityKey2: [], // 委托进口协议
                qualityKey3: [], //质检报告
                qualityKey4: [], // 人物肖像授权资源 
                qualityKey5: [], // 老字号认证证书
                qualityKey6: [], // 赠品资源
                skuList: [],
                specifications: [],
                productFormat: '',
                categoryAttrValue: '{}', // 类目属性(不包含产品数字身份证)
                digitalIDAttrValue:{}, // 产品数字身份证属性
                timeSpecList: [], // 预售发货时效数组
                templateConfig: null,
                sizeTemplateList:[],
                sizeTemplateConf: [],
                sizePicUrl: '',
                shortTitle: '',
                guideImg: [],
                threeGuarantees:{
                    serviceType:null,
                    duration:null
                },// 三包服务
                shippingOriginInfo: {
                    shippingOriginId: '',
                    shippingOriginType: ''
                },
            },
            deliveryRules:{
                minDays: 3,
                maxDays: 30,
            },
            deliveryModes: [],
            payWayModes: [
                {label: '货到付款', value: 0},
                {label: '在线支付', value: 1},
                {label: '货到付款+在线支付', value: 2},
            ],
            reduceModes: [
                {label: '拍下减库存', value: 1},
                {label: '付款减库存', value: 2}
            ],
            deliveryAfterPresellConfig: {},
            skuClassificationRule: null,
            stepRule: {},
            supplyDayReturnList: [],
            threeGuarantees:{},// 三包服务选项
            homeInstallServiceRule: {},
            isLoadedProductUpdateRule: false,
            normalDelayOptions: [],
            timeSpecLabels: [],
            brandIdOptions: [], // 品牌列表
            rules: RULES(this),
            selectLoading: false,
            shipsTemplate: null, // 运费模板列表
            shipsValue: null, // 运费模板值
            templateConfigMap: null, // 初始值
            originalTemplateConfig: null, // 原始运费模板配置（用于保存时恢复未显示店铺的数据）
            originalShopBrandConf: null, // 原始品牌配置（用于保存时恢复未显示店铺的数据）
            originalSizeTemplateConf: null, // 原始店铺尺码表配置（用于保存时恢复未显示店铺的数据）
            isOnshelf: 1,
            // 抖音资质信息
            qualityList: [],
            isHasNameFix: false,
            dialogImageUrl: [],
            auditFileList: [],
            supportPropertyDiy: false,
            originSpecifications: [],    
            unrenderSpecList: [],
            needlessSpecList: [],
            requiredSpecDetails: [],
            maxSpecNumLimit: 0,
            specSingleLimit: 0,
            fxgProductUpdateRuleParams: {},  
            subPropertyCategoryData: [],
            operateRowData: [],
            operateSkuIndex: -1,
            componentTemplateRule: null, // 尺码校验
            referencePriceRule: {},
            autoCropImageConfigList:[],
            detailCategoryId: '',
            detailCategoryIdChange: false,
            fxgRecommendId: '',
            timeSkuPresellWithNormalRule:{
                support: true
            },
            stepRule:{},
            detailHasCategory:[],
            allSaveDeliveryMode: [],
            categoryAttrList:[], // 类目属性
            skuPictureRule:{}, // SKU图片规则
            shippingOriginRule: {}, // 发货地规则
            batchSetSKUImgVisible:false,
            titleValidResult: '', // 标题前置校验结果
        }
    },
    computed: {
        ...mapGetters(['shops_getCategoryPropShopId', 'userInfo']),
        // checkSize() {
        //     return !!this.value.sizeTemplateList?.length;
        // },
        watchList: function() {
            const obj = {}
            Object.keys(this.value).forEach(key => {
                obj[key] = this.value[key]
            })
            return obj
        },
        certificateTypeEnum() {
            const enums = [];
            const { certificateTypes = {} } = this.referencePriceRule;
            Object.keys(certificateTypes).forEach(key => {
                enums.push({
                    label: certificateTypes[key],
                    value: Number(key)
                });
            });
            return enums;
        },
        shippingOriginOptions() {
            const shippingOriginType = String(this.value.shippingOriginInfo?.shippingOriginType || '');
            const typeRule = (this.shippingOriginRule.options || []).find(item => String(item.value) === shippingOriginType);
            return typeRule?.options || [];
        },
        shippingOriginInfoRules() {
            return getShippingOriginInfoRules(this);
        },
        discountPrice() {
            const minPrice = _.minBy(this.skuList, (item) => {
                return item.price;
            })?.price;
            const maxPrice = _.maxBy(this.skuList, (item) => {
                return item.price;
            })?.price;
            if (minPrice === maxPrice) {
                return minPrice;
            }
            return `${minPrice || 0}~${maxPrice || 0}`
        },
        categoryId() {
            const categoryIds = this.value.categoryIds || []
            return categoryIds[categoryIds.length -1]
        },
        skuTableCols() {
            let newSkuCols = _.cloneDeep(skuTableCols(this));
            let { presellType, timeSpecList } = this.value || {};
            if (this.skuClassificationRule) {
                const { options, enable } = this.skuClassificationRule;
                if (enable === true) {
                    const formatOptions = options.map(item => {
                        const { name, description, value } = item;
                        return {
                            value,
                            label: name,
                            description
                        }
                    })
                    const skuClassificationTypeCol = {
                        prop: 'extendId1',
                        attrs: {label: 'SKU分类', noRequired: true},
                        input: {type: 'select' },
                        items: formatOptions
                    };
                    newSkuCols.splice(2, 0, skuClassificationTypeCol);
                }
            }
            if(presellType === 2 && timeSpecList.length) {
                const stockIndex = newSkuCols.findIndex(col => col.prop === 'stockNum') || 2
                const addCols = []
                timeSpecList = timeSpecList.sort((a,b) => a - b)
                timeSpecList.map(time => {
                    const findItem = this.timeSpecLabels.find(item => item.timeType == time);
                    if (findItem) {
                        addCols.push({
                        prop: `multiTimeStocks_${time}`,
                        attrs: { label: `预售库存(${findItem.timeDesc})`, noRequired: true },
                        input: {
                            type: 'number',
                            disabled: false,
                            validator(value, prop) {
                            if (value && value < 0) {
                                return `商品明细中 ${prop.label || prop.name} 不能小于0`;
                            }
                            return false;
                            },
                        },
                        });
                    }
                });
                newSkuCols.splice(stockIndex + 1, 0, ...addCols);
            }
            if(this.openSource === 'shopGoods'){
                newSkuCols = newSkuCols.filter(col => col.prop !== 'code')
            }
            return newSkuCols
        },
        shopList() {
            let list = this.getShopList(this.platform).filter(shop => shop.source === 'fxg');
            if(this.openSource === 'shopGoods'){
                list = list.filter(item => item.id == this.formData.shopId)
            }
            return list
        },
        fxgAndGxShopList() {
            return this.getShopList(this.platform)
        },
        shopId() {
            return this.shops_getCategoryPropShopId('fxg')
        },
        // 产品数字身份证属性
        digitalIDList(){
            return (this.categoryAttrList || []).filter(item => item.featureTypeList && item.featureTypeList.includes(48))
        },
        isCheckMainImg(){
            return this.isCheckImg('mainImg')
        },
        isCheckMainImg34(){
            return this.isCheckImg('mainImg34')
        },
        isCheckGuideImg(){
            return this.isCheckImg('guideImg')
        },
        isCheckWhiteImg(){
            return this.isCheckImg('whiteImg')
        },
        isCheckDesc(){
            return this.isCheckImg('desc')
        },
        isCheckSkuImg(){
            return this.isCheckImg('skuImg')
        },
        isCheckSkuPicture(){
            return this.isCheckImg('skuPicture')
        },
        threeGuaranteesDurationOptions(){
            let type = this.value.threeGuarantees.serviceType
            let obj = (this.threeGuarantees.options || []).find(item => item.value === type)
            return obj?.options || []
        },
        fxgSuggestions() {
            const suggestions = []
            // 白底图
            if (!this.dialogImageUrl || !this.dialogImageUrl[0]) {
                suggestions.push({
                    label: '白底图',
                    message: '根据抖音平台视觉合规检测要求，白底图缺失，使用第三方商品发布工具发布商品时，仅支持发布至草稿箱。需补全白底图及商品视频后才支持上架。',
                    prop: 'dialogImageUrl',
                })
            }
            // 商品视频
            if (!this.value.videoInfo || !this.value.videoInfo[0]) {
                suggestions.push({
                    label: '商品视频',
                    message: '根据抖音平台视觉合规检测要求，商品视频缺失，使用第三方商品发布工具发布商品时，仅支持发布至草稿箱。需补全白底图及商品视频后才支持上架。',
                    prop: 'videoInfo',
                })
            }
            // 7天无理由退货
            const returnVal = this.value.supplyDayReturnSelector || ''
            if (returnVal === '7-0') {
                suggestions.push({
                    label: '无理由退货服务',
                    message: '建议选择7天无理由退货或48小时无理由退货，获取更多曝光和流量。',
                    prop: 'supplyDayReturnSelector',
                })
            }
            return suggestions
        }
    },
    watch: {
        formData: {
           async handler(form) {
                if(_.isEmpty(form)) return
                const v = cloneDeep(form)
                // 保存原始 templateConfig，用于保存时恢复未显示店铺的数据
                if (v.templateConfig && v.templateConfig.length) {
                    this.originalTemplateConfig = cloneDeep(v.templateConfig);
                }
                // 保存原始 shopBrandConf，用于保存时恢复未显示店铺的数据
                if (v.shopBrandConf && v.shopBrandConf.length) {
                    this.originalShopBrandConf = cloneDeep(v.shopBrandConf);
                }
                // 保存原始 sizeTemplateConf，用于保存时恢复未显示店铺的数据
                if (v.sizeTemplateConf && v.sizeTemplateConf.length) {
                    this.originalSizeTemplateConf = cloneDeep(v.sizeTemplateConf);
                }
                if(v.skuFix && v.categoryIds?.length) {
                    this.$message.warning('有未匹配的规格明细，当前商品规格是从基础资料同步的数据，保存后生效');
                }
                if (v.skuList) {
                    v.skuList = v.skuList.map(item => {
                        const _skuid = item.skuSpecifications.filter(sp => sp.valueKey).map(sp => sp.valueKey).join('-')
                        const multiTimeStocks = Array.isArray(item.multiTimeStocks) ? item.multiTimeStocks : JSON.parse(item.multiTimeStocks || '[]')
                        multiTimeStocks.forEach(stockItem => {
                            item[`multiTimeStocks_${stockItem.timeType}`] = stockItem.stockNum
                        })
                        return {
                            ...item,
                            multiTimeStocks,
                            _skuid
                        }
                    })
                    // this.skuList = _.cloneDeep(v.skuList);
                }
                if (v.specifications && v.specifications.length) {
                    this.originSpecifications = JSON.parse(JSON.stringify(v.specifications));
                }
                if (!v.reduceType) {
                    v.reduceType = 1
                }
                if (!v.timeSpecList) {
                    v.timeSpecList = []
                }
                v.presellType = v.presellType == 3 ? 0 : v.presellType;  // 兼容历史数据
                this.dialogImageUrl[0]=this.formData.whiteBackGroundPicUrl || '';
                const { initAttrData, initMeasureData } =  parseProductFormat(v.productFormat);
                this.$set(this, 'initAttrData', initAttrData);
                this.$set(this, 'initMeasureData', initMeasureData);
                if(v.presellEndTime){
                    // 存在结束时间
                    v.presellEndTimeType = 1
                } else {
                    // 无结束时间
                    v.presellEndTimeType = 2
                }
                v.referencePriceCertificate = typeof v.referencePriceCertificate === 'string' ? JSON.parse(v.referencePriceCertificate || '{"certificate_type":"","certificate_urls":[]}') : v.referencePriceCertificate;
                this.detailHasCategory = v.categoryIds
                this.detailCategoryId = v.categoryIds ? v.categoryIds[v.categoryIds.length - 1] : '';
                // 三包服务
                if(v.threeGuarantees){
                    let obj = JSON.parse(v.threeGuarantees);
                    // 由于平台返回的默认值跟发布规则返回的选项值类型不一样，这里将值转为字符串处理
                    for(let key in obj){
                        if(obj[key]){
                            obj[key] = obj[key] + ''
                        }
                    }
                    v.threeGuarantees = obj
                }else{
                    v.threeGuarantees = this.value.threeGuarantees
                }
                // 属性图处理
                if(v.categoryPropertyPics){
                    try{
                        v.categoryPropertyPics = JSON.parse(v.categoryPropertyPics)
                    }catch(e){
                        console.log(e)
                        v.categoryPropertyPics = {}
                    }
                }
                this.$set(this, 'value', v)
                this.getConf();
                await this.queryHasFxgNeedProductNameFix();
                await this.handleGetScmCodeFxgPlat();
                this.handlePredictionCategory();
                this.getDayRetrunList();
                this.$forceUpdate();
                this.$nextTick(() => {
                    if(v.ifNew) {
                        this.getFxgProductNameFix();
                    }
                })
            },
            immediate: true
        },
        "value.categoryIds": {
            // deep: true,
            // immediate: false,
            handler(v, oldVal) {
                const newStrVal = v ? v.toString() : '';
                const oldStrVal = oldVal ? oldVal.toString() : '';
                if (newStrVal === oldStrVal) {
                    return false;
                }
                // setTimeout(()=>{
                //     this.$refs.categoryInput.handleNameToChangeCate({categoryIds:v}); 
                // },1000)
                // 分类改变需要将一些随类目改变的表单值重置
                // 重置品牌
                // this.value.brandId = ''
                // 重置类目属性
                // this.value.productFormat = ''
                // this.$set(this, 'initAttrData', parseProductFormat(''));
                this.getFxgQualityList(v);
                if((this.detailCategoryId != this.value.categoryIds[this.value.categoryIds.length - 1]) || this.detailCategoryIdChange){
                    this.detailCategoryIdChange = true
                    this.$nextTick(() => {
                        this.$refs.BrandIdBlockRef?.useBrandConfInit();
                    });
                }
            },
        },
        'value.presellType': {
            handler(newVal) {
            // 当切换到现货+预售发货模式时，将单选值转为数组
            if (newVal === 2) {
                if(this.value.deliveryDelayDay == 0 ){
                    this.value.deliveryDelayDay = [];
                } else {
                    this.value.deliveryDelayDay = this.value.deliveryDelayDay ? [this.value.deliveryDelayDay] : [];
                }
            } else if (Array.isArray(this.value.deliveryDelayDay)) {
            // 当从现货+预售发货模式切换到其他模式时，取数组第一个值或设为默认值
                this.value.deliveryDelayDay = this.value.deliveryDelayDay[0] || this.normalDelayOptions[0].value;
            } else if (newVal === 1) { // 全款预售发货模式
                this.$set(this.value, 'presellDeliveryType', 1);
                this.$set(this.value, 'presellDelay', 3);
            }
            },
        },
        'value.presellEndTimeType': {
            handler(newVal) {
                if (newVal === 2) { // 无结束时间
                    this.value.presellEndTime = ''
                    this.value.presellDeliveryType = 1; // 强制设为支付完成后
                    this.allSaveDeliveryMode = [
                        {label: '支付完成后', value: 1}
                    ]
                } else {
                    this.allSaveDeliveryMode = [
                      {label: '预售结束后', value: 0},
                      {label: '支付完成后', value: 1}
                    ]
                }
            }
        },

        "value.sizeType": {
            deep: true,
            handler(v, oldVal) {
                // 切换时，移除店铺尺码的校验并清空错误
                this.$refs.form && this.$refs.form.clearValidate(['sizeTemplateConf']);
            }
        },
        'value.categoryAttrValue':{
            handler(v) {
                // 将2份数据合成一份
                let categoryAttrValue = JSON.parse(v || '{}');
                let digitalIDAttrValue = JSON.parse(this.value.digitalIDAttrValue || '{}');
                this.value.productFormat = JSON.stringify({...categoryAttrValue,...digitalIDAttrValue});
            },
        },
        'value.digitalIDAttrValue':{
            handler(v) {
                // 将2份数据合成一份
                let digitalIDAttrValue = JSON.parse(v || '{}');
                let categoryAttrValue = JSON.parse(this.value.categoryAttrValue || '{}');
                this.value.productFormat = JSON.stringify({...categoryAttrValue,...digitalIDAttrValue});
            },
        },
        dialogImageUrl: {
            deep: true,
            handler() {
                this.emitSuggestions()
            }
        },
        'value.videoInfo': {
            deep: true,
            handler() {
                this.emitSuggestions()
            }
        },
        'value.supplyDayReturnSelector': {
            handler() {
                this.emitSuggestions()
            }
        },
    },
    mounted() {
        this.getFxgQualityList();
        this.dialogImageUrl[0]=this.formData.whiteBackGroundPicUrl || '';
    },
    unmounted() {
        this.detailCategoryIdChange = false
    },
    methods: {
        handleShippingOriginTypeChange() {
            this.$set(this.value.shippingOriginInfo, 'shippingOriginId', '');
            this.$nextTick(() => {
                this.$refs.form && this.$refs.form.validateField('shippingOriginInfo');
            });
        },
        handleShippingOriginChange() {
            this.$refs.form && this.$refs.form.validateField('shippingOriginInfo');
        },
        textLength(text) {
            return getBytesCount_v2(text || '');
        },
        getTelephoneConf() {
            // * loginIdentity(1:供销商； 2:分销商)
            let userInfo = this.$store.getters.userInfo;
            this.isSupplier = userInfo.loginIdentity === 1 ? true : false;
            this.$router.replace({
                path: !this.isSupplier ? '/distributor/prod_conf' : '/supplier/prod_conf',
                query: { platform: this.platform, platformName: '抖音', tabName:'distribution' },
            }).catch(err => {
                if (err.name === 'NavigationDuplicated') {
                    return;
                }
                throw err;
            });
            this.$emit('redirect');
        },
        handleDeliveryDelayDayChange(values) {
            if (values.length > 1) {
                // 如果选中多个，只保留最后选中的值
                this.value.deliveryDelayDay = [values[values.length - 1]];
            }
        },
        handleFxgRecommendIdUpdate(value){
            this.fxgRecommendId = value
        },
        isCheckImg(type){
            return !this.autoCropImageConfigList.includes(type);
        },
        getWidthAndHeights(refName) {
            return this.$refs[refName].getWidthAndHeights ? this.$refs[refName].getWidthAndHeights() : []
        },
        async handleGetScmCodeFxgPlat(){
            const res = await getScmCodeFxgPlat()
            // 兼容noLimitFxgCat不存在的情况，当该key不存在或为false时，都隐藏类目选择
            if(res && res.noLimitFxgCat === true){
                // TRUE为不限制，就展示类目选择，否则就不展示类目选择
                this.hideEditBtn = false
            } else {
                this.hideEditBtn = true
            }
        },
        onSizePicUrlChange(url) {
            this.value.sizePicUrl = url
        },
        openShopSize(payload, type){
            this.previewTemplateInfo = payload
            if(!(payload.templateInfo && payload.templateInfo.templateId)){
                this.$message.error('数据模版未选择，不能' + (type === 'edit' ? '编辑' : '预览'))
                return
            }
            this.dialogType = type
            const opts = { previewTemplateInfo: payload }
            if (type === 'edit') opts.dialogType = 'edit'
            this.showAddSize(opts)
        },
        showAddSize({previewTemplateInfo,dialogType}) {
            this.$refs.addSizeDialog.method_open({previewTemplateInfo,dialogType})
        },
        delSize() {
            this.value.sizeTemplateList = [];
        },
        handleSkuSelectionChanged(rowData) {
            this.operateRowData = rowData;
        },
        // 处理 sku 图片上传
        handleSkuPictureUpload(row, url, index) {
            row.skuPictureUrl = url;
            row.skuPictureErrMsg = '';
            row._waitingImgValidate = true; // 标记等待图片校验
            this.specificationsFieldChanged();
        },
        // 处理 sku 图片删除
        handleSkuPictureDel(row, index) {
            row.skuPictureUrl = '';
            row.skuPictureErrMsg = '';
            this.specificationsFieldChanged();
        },
        // 图片加载完成后校验（使用 ImgUpload 组件内部的 method_validImage 方法）
        async handleSkuPictureLoaded(row, index) {
            // 只有等待校验的图片才需要校验
            if(!row._waitingImgValidate) {
                return;
            }
            row._waitingImgValidate = false;

            const refKey = `skuPicture_${index}`;
            const refImg = this.$refs[refKey];

            // refImg 可能是对象或数组，统一处理
            const imgComponent = Array.isArray(refImg) ? refImg[0] : refImg;

            if (imgComponent && typeof imgComponent.method_validImage === 'function') {
                const errMsg = await imgComponent.method_validImage();
                // row.skuPictureErrMsg = errMsg || '';
                this.$set(row,'skuPictureErrMsg',errMsg || '')
                // 强制更新视图
                this.$forceUpdate();
            } else {
                console.log('refImg not found or invalid');
            }
        },
        handleNameBlur(){
            this.handlePredictionCategory();
        },
        // 前置校验（复用rules.js中的checkTitleValid），不通过则不调用接口
        passLocalTitleValidate() {
            return checkTitleValid(this.value.name, {
                isHasNameFix: this.isHasNameFix,
                namePrefix: this.value.namePrefix
            }).valid;
        },
        async validateTitleAsync() {
            const { name, categoryIds } = this.value;
            if (!name || !categoryIds?.length || !this.passLocalTitleValidate()) {
                this.titleValidResult = '';
                return;
            }
            const shopId = this.shops_getCategoryPropShopId('fxg');
            try {
                const res = await fxgPublishPreCheckTitle({ shopId, name });
                if (res && res.data && res.data.checkResultCode !== 0) {
                    this.titleValidResult = res.data.checkResultMsg || '';
                } else {
                    this.titleValidResult = '';
                }
            } catch (e) {
                this.titleValidResult = '';
            }
        },
        handlePredictionCategory(){
            let extraParams = {}
            if(this.openSource === 'shopGoods'){
                const { numIid,shopId,source } = this.rowData
                extraParams = {
                    itemInfo:{...this.formData},
                    shopId,
                    platform:source,
                    platformItemId:numIid,
                }
            }
            this.$refs.categoryInput.handleNameToChangeCate({
                title: this.value.name || '',
                extraParams,
                predictionedFn: predictionCategory => {
                    if(this.value.categoryIds?.length) {
                        const currentCategoryStr = this.value.categoryIds.join();
                        // 调用类目预测接口，获取TOP3推荐类目，若已选类目未包含于TOP3预测类目，则清空类目信息；
                        const hasMatch = predictionCategory.some(item => item.cidS.join() === currentCategoryStr)
                        // 如果在预测内容之内，不用将内容情空
                        if(this.hideEditBtn && !hasMatch){
                            this.value.categoryIds = []
                        }
                    }
                    this.validateTitleAsync();
                }
            }); 
        },
        getSpecPicNum(specifications) {
            let num = 0;
            specifications.forEach(spec => {
                (spec.values || []).forEach(v => {
                    if (v.checked && v.imageUrl) {
                        num += 1;
                    }
                })
            });
            return num;
        },
     
        // 视频上传成功
        videoUploadSuccess(viedo) {
            this.$set(this.value.videoInfo, 0, viedo);
            this.emitSuggestions();
        },
        // 删除视频
        videoDel() {
            this.$set(this.value.videoInfo, 0, null);
            this.emitSuggestions();
        },
        emitSuggestions() {
            console.log(this.fxgSuggestions, '---suggestions---')
            this.$emit('form-suggestions', this.fxgSuggestions)
        },
        async valid_specifications() {
            this.specificationsValidResult = true
            return new Promise(async (resolve, reject) => {
                if (this.$refs.fxgSpecification) {
                    const specIsValid = this.$refs.fxgSpecification.validateSpecLimit();
                    if (specIsValid !== true) {
                        this.specificationsValidResult = specIsValid;
                        resolve(false);
                        return;
                    }
                    const fxgSpecificationValid = await this.$refs.fxgSpecification.validateSpecValueForm();
                    if (!fxgSpecificationValid) {
                        this.specificationsValidResult = '请检查商品规格信息是否正确维护';
                        resolve(false);
                        return;
                    }
                } else {
                    resolve(false);
                    return;
                }
                const specificationsValid = this.validateSpecifications();
                this.specificationsValidResult = specificationsValid;
                if (specificationsValid !== true) {
                    resolve(false);
                    return;
                }
                const [specifications, skuList] = this.getSpecificationData();
                if (!this.validateImgsAllFillOrNot(specifications)) {
                    this.specificationsValidResult = '规格图片请全补全或全清空';
                    resolve(false);
                    return;
                }
                if (this.titleValidResult) {
                    resolve(false);
                    return;
                }
                resolve(true);
            });
        },
        // 校验规格图片是否都填写了或者都没填写
        validateImgsAllFillOrNot(specifications) {
            let isFill = false;
            let isAllSame = true;
            if (specifications.length > 0) {
                (specifications[0].values || []).forEach((item, index) => {
                    if (index === 0) {
                        isFill = !!item.imageUrl
                        return ;
                    }
                    if (!isAllSame) return;
                    if (!!item.imageUrl !== isFill) {
                        isAllSame = false;
                    }
                })
            }
            return isAllSame
        },
        // 获取需要缓存的数据
        method_getSavedCachedData() {
            // const cachedData = this.getSubmitFormData();
            const cachedData = _.cloneDeep(this.value);
            const [specifications, skuList] = this.getSpecificationData()
            delete cachedData['specifications']
            delete cachedData['skuList']
            const { referencePriceCertificate, referencePrice } = cachedData;
            if (referencePrice) {
                cachedData['referencePriceCertificate'] = JSON.stringify(referencePriceCertificate)
            } else {
                cachedData['referencePriceCertificate'] = '';
            }
            const newSpecifications = formatSubmitSpecs(_.cloneDeep(specifications));
            return {
                hasEditFlag: this.hasEditFlag,
                cachedData: {
                    otherInfo: JSON.stringify(cachedData),
                    specJsonStr: JSON.stringify(newSpecifications),
                    skuJsonList: JSON.stringify(this.skuList),
                },
            }
        },
        method_resetCachedData() {
            this.$refs.categoryInput?.handleReset();
        },
        async method_getFormData() {
            const [specifications, skuList] = this.getSpecificationData();
            const value = this.value || {};

            if (this.$refs.BrandIdBlockRef) {
                const brandValid = await this.$refs.BrandIdBlockRef.method_validate();
                if (!brandValid) {
                    this.$message.error('请完善表单');
                    return false;
                }
            }

            if (!this.validateImgsAllFillOrNot(specifications)) {
                this.specificationsValidResult = '规格图片请全补全或全清空';
                return false;
            }

            // 规格数据整理
            this.value.specifications = formatSubmitSpecs(_.cloneDeep(specifications));

            // SKU 发货时效整理
            const timeSpecListRaw = Array.isArray(value.timeSpecList) ? [...value.timeSpecList] : [];
            const timeSpecListSorted = timeSpecListRaw.sort((a, b) => a - b);

            const newSkuList = _.cloneDeep(skuList).map(sku => {
                const multiTimeStocks = [];
                timeSpecListSorted.forEach(time => {
                    const findItem = (this.timeSpecLabels || []).find(item => item.timeType == time);
                    if (findItem) {
                        multiTimeStocks.push({
                            stockNum: sku[`multiTimeStocks_${time}`] || 0,
                            timeDesc: findItem.timeDesc,
                            timeType: time,
                        });
                    }
                    // 清理临时字段
                    delete sku[`multiTimeStocks_${time}`];
                });
                sku.skuStatus = sku.skuStatus ? 1 : 0
                return { ...sku, multiTimeStocks: JSON.stringify(multiTimeStocks) };
            });
            this.value.skuList = newSkuList;

            const valid = await this.validPage();
            if (!valid) {
                this.$message.error('请完善表单');
                return false;
            }

            // fxg 数据映射
            let data = cloneDeep(this.value);
            // let data = fxgDataMap(this.value, true);
            if (this.value.sizeType == 1) {
                const addSizeData = await this.$refs.addSizeRef.method_getData();
                if (!addSizeData) {
                    // this.$message.error('请完善商品尺码');
                    return false;
                } 
                if(Object.keys(addSizeData).length === 0) {
                    data.sizeTemplateList = []
                } else {
                    data.sizeTemplateList = [{ ...addSizeData, bizType: 1 }]
                }
            } else if (this.value.sizeType == 3) {
                const validShopSizeError = this.$refs.shopSizeRef.validateForm();
                if (!validShopSizeError) {
                    this.$message.error('请完善店铺尺码');
                    return false;
                }
            }

            // 质检凭证整理
            const productQualityVOS = (this.qualityList || []).map(item => ({
                ...item,
                qualityAttachments: (item.images || []).map(a => ({
                    media_type: 1,
                    url: a,
                })),
            }));

            // 预售时效整理（按指定顺序）
            const preSaleTimeList = (this.timeSpecLabels || [])
                .filter(item => Array.isArray(data.timeSpecList) && data.timeSpecList.includes(item.timeType))
                .map(item => item.timeType)
                .sort((a, b) => a - b);

            if (data.presellType === 2) {
                const delay = data.deliveryDelayDay;
                if (delay != 0) {
                    const delayList = Array.isArray(delay) ? delay : [delay];
                    data.timeSpecList = [...delayList, ...preSaleTimeList];
                } else {
                    data.timeSpecList = [...preSaleTimeList];
                }
            } else {
                data.timeSpecList = [...preSaleTimeList];
            }

            const referencePrice = data.referencePrice;
            const referencePriceCertificate = data.referencePriceCertificate || {};
            if (referencePrice) {
                delete referencePriceCertificate.certificateType;
                delete referencePriceCertificate.certificateUrls;
                try {
                    data.referencePriceCertificate = JSON.stringify(referencePriceCertificate);
                } catch (e) {
                    data.referencePriceCertificate = '';
                }
            } else {
                data.referencePriceCertificate = '';
            }

            data.categoryRecommendId = this.fxgRecommendId;

            if (data.presellEndTimeType) {
                if (data.presellEndTimeType == 2) data.presellEndTime = '';
                delete data.presellEndTimeType;
            }

            // 三包服务
            if(this.threeGuarantees.enable){
                data.threeGuarantees = JSON.stringify(data.threeGuarantees);
            } else {
                delete data.threeGuarantees;
            }
            // 属性图
            if(data.categoryPropertyPics){
                try{
                    data.categoryPropertyPics = JSON.stringify(data.categoryPropertyPics)
                }catch(e){}
            }

            const shopId = this.shops_getCategoryPropShopId('fxg');
            delete data.categoryNames;
            // console.log(_.cloneDeep(data), '-------data---');
            // return
            return {
                ...data,
                itemCompleteness: true,
                discountPrice: null,
                shopBrandConf: this.mergeHiddenShopData(cloneDeep(data.shopBrandConf), this.originalShopBrandConf, this.fxgAndGxShopList),
                templateConfig: (() => {
                    let current = JSON.parse(this.handleTemplateConfig());
                    current = this.mergeHiddenShopData(current, this.originalTemplateConfig, this.fxgAndGxShopList);
                    return JSON.stringify(current);
                })(),
                sizeTemplateConf: this.mergeHiddenShopData(cloneDeep(data.sizeTemplateConf), this.originalSizeTemplateConf, this.fxgAndGxShopList),
                isOnshelf: this.isOnshelf,
                shopId,
                paramShopId: shopId,
                productQualityVOS,
                whiteBackGroundPicUrl: (this.dialogImageUrl && this.dialogImageUrl[0]) || ''
            };
        },
        handleTemplateConfig() {
            const arr = [];
            Object.keys(this.shipsValue).forEach(key => {
                this.shipsTemplate[key].forEach(item => {
                    if(item.id == this.shipsValue[key]){
                        const channel = this.fxgAndGxShopList.find(shop => shop.id == key)?.channel
                        arr.push({
                            shopId: key,
                            templateId: item.id,
                            templateName: item.name,
                            channel
                        })
                    }
                })
            })
            return JSON.stringify(arr);
        },
        // 处理抖音详情 templateConfig
        initTemplateConfig(templateList = []) {
            const ships = {};
            this.fxgAndGxShopList.forEach((shop) => {
                ships[shop.id] = '';
            });
            const templateConfigMap = {};
            this.value.templateConfig = this.value.templateConfig || []
            this.value.templateConfig.forEach(item => {
                templateConfigMap[item.shopId] = {
                    templateId: item.templateId,
                    templateName: item.templateName
                };
            })
            templateList.forEach(item => {
                if(!templateConfigMap[item.shopId]){
                    templateConfigMap[item.shopId] = {
                    templateId: item.templateId,
                    templateName: item.templateName
                };
                }
            })
            this.templateConfigMap = templateConfigMap;
            Object.keys(templateConfigMap).forEach(key => {
                ships[key] = templateConfigMap[key].templateId
            })
            this.shipsValue = ships;
            this.initShipsTemplate(templateConfigMap);
        },
        // 处理每个店铺下拉框
        initShipsTemplate(templateConfigMap) {
            const shipsTemplate = {};
            this.fxgAndGxShopList.forEach(shop => {
                shipsTemplate[shop.id] = []
            });
            Object.keys(templateConfigMap).forEach(key=> {
                shipsTemplate[key] = [{
                    id: templateConfigMap[key].templateId || '',
                    name: templateConfigMap[key].templateName || '',
                }]
            })
            this.shipsTemplate = shipsTemplate;
        },
        // 获取配置
        async getConf() {
            const res = await getDistributionConfig({shopType: 'TouTiaoFXG'});
            // 上架设置
            this.isOnshelf = this.value.isOnshelf || this.value.isOnshelf === 0 ? this.value.isOnshelf : res?.shelfState;
            // 针对未完善资料的抖音资料
            if(!this.value.categoryIds?.length){
                this.value.sizeType = res.sizeType || 3
            }
            // 运费模板
            this.initTemplateConfig(res?.templateList || []);
            // 初始化尺码模版
            this.resSizeTemplateConf = res.sizeTemplateList || [];
            this.initSizeTempConfig(res?.sizeTemplateList || [])
            this.autoCropImageConfigList = res.autoCropImageConfigList ? res.autoCropImageConfigList : [];
            if(this.autoCropImageConfigList.length){// 异步获取到不用校验图片尺寸的情况，重新校验一下刷新状态
                setTimeout(() => {
                    this.validPage();
                }, 3000)
            }
        },
        mergeArrays(arr1, arr2) {
            const shopIdMap = new Map();
            const result = [];
            
            // 处理arr1（优先级最高）
            for (const item of arr1) {
                if (!shopIdMap.has(item.shopId))  {
                    shopIdMap.set(item.shopId,  true);
                    result.push(item); 
                }
            }
            
            // 处理arr2（仅添加不重复的shopId）
            for (const item of arr2) {
                if (!shopIdMap.has(item.shopId))  {
                    shopIdMap.set(item.shopId,  true);
                    result.push(item); 
                }
            }
            
            return result;
        },
        initSizeTempConfig(sizeTemplateConf){
            // const useSizeTemplateList = this.mergeArrays(this.value.sizeTemplateConf, sizeTemplateConf);
            let useSizeTemplateList = this.value.sizeTemplateConf
            if(sizeTemplateConf.length && (this.value.sizeTemplateConf.length == 0 || !this.value.sizeTemplateConf)){
                useSizeTemplateList = sizeTemplateConf
            }
            this.value.sizeTemplateConf = useSizeTemplateList 
        },
        queryTemplates(queryName, shop) {
            this.getTemplateList(shop, queryName)
        },
        changeSelect(isVisible, shop) {
            if(!isVisible) return
            const shopId = shop.id;
            if(!this.shipsValue[shopId]) {
                this.getTemplateList(shop, '')
            }
        },
        // 获取模板
        async getTemplateList(shop, name) {
            this.selectLoading = true;
            const userId = shop.userId;
            const shopId = shop.id;
            let list = []
            if(shop.source === 'fxg_gx') {
                list = await getFxgGxTemplateList({userId});
            } else {
                list = await getFxgTemplateList({userId, name, page: 0, size: 30});
                list = list.map(ship => {
                    const temp = ship.template || {};
                    return {
                        name: temp.templateName,
                        id: temp.id
                    }
                })
            }
            this.selectLoading = false;
            this.$set(this.shipsTemplate, shopId, list);
            const findItem = list.find(item => item.id === this.shipsValue[shopId]);
            this.shipsValue[shopId] = findItem ? '' : this.shipsValue[shopId];
        },
        addOrUpdateSizeTemplate(sizeTemplate) {
            if(this.dialogType == 'edit'){
                // 确保 sizeTemplateConf 数组存在
                if (!this.value.sizeTemplateConf) {
                    this.$set(this.value, 'sizeTemplateConf', []);
                }
                
                // 根据 shopId 查找对应的店铺数据索引
                const shopId = sizeTemplate.shopId;
                const existingIndex = this.value.sizeTemplateConf.findIndex(item => item.shopId === shopId);
                
                if (existingIndex !== -1) {
                    // 如果找到对应的店铺数据，进行替换
                    this.$set(this.value.sizeTemplateConf, existingIndex, sizeTemplate);
                    this.$refs.shopSizeRef.initValuesMap();
                } else {
                    // 如果没有找到对应的店铺数据，添加新的数据
                    // 使用 Vue.set 或者重新赋值整个数组来确保响应式更新
                    const newArray = [...this.value.sizeTemplateConf, sizeTemplate];
                    this.$set(this.value, 'sizeTemplateConf', newArray);
                }
                this.previewTemplateInfo.editSuccessFn(sizeTemplate);
            }
        },

        // 抖音资质信息
        async getFxgQualityList(_categoryIds) {
            let { categoryIds } = this.value;
            let categories = _categoryIds || categoryIds;
            if(!categories || !categories.length) {
                return;
            }
            let categoryLeafId = last(categories);
            let shopId = this.shops_getCategoryPropShopId('fxg') || 76398;
            let res;
            if(this.openSource === 'shopGoods'){ // 店铺商品的单独处理
                const { companyId,qualityList,qualityKey1,qualityKey2,qualityKey3,qualityKey4,qualityKey5,qualityKey6 } = this.formData
                let params = {
                    shopId,
                    categoryLeafId,
                    companyId,
                    qualityList,
                    qualityKey1:qualityKey1.join(','),
                    qualityKey2:qualityKey2.join(','),
                    qualityKey3:qualityKey3.join(','),
                    qualityKey4:qualityKey4.join(','),
                    qualityKey5:qualityKey5.join(','),
                    qualityKey6:qualityKey6.join(','),
                }
                res = await fxgSearchProductQualityList2(params);
            }else{
                res = await fxgSearchProductQualityList({
                    shopId,
                    baseItemId: this.baseItemId,
                    categoryLeafId,
                });
            }
            let data = get(res, 'data', []);
 
            (data || []).forEach(item => {
                item.images = this.getMultiImages(item.qualityAttachments);
            });
            this.qualityList = data;
        },
        categoryIdsChange(categoryIds, lables) {
            this.getTitleNameFix(categoryIds, lables);
            this.getDayRetrunList(categoryIds, lables);
            // this.value.timeSpecList = [];
        },
        categoryNamesChange(names, categoryIds) {
            this.value.categoryNames = names;
        },
        setShopCache(){
            this.$emit('setShopCache')
        },
        getTitleNameFix(categoryIds, lables){
            this.queryHasFxgNeedProductNameFix();
            this.getFxgProductNameFix(categoryIds, lables);
        },
        async queryHasFxgNeedProductNameFix() {
            let { categoryIds } = this.value;
            if(!categoryIds || !categoryIds.length) {
                return;
            }
            let categoryLeafId = last(categoryIds);
            let shopId = this.shops_getCategoryPropShopId('fxg') || 76398;
            let isNeedRes = await queryFxgNeedProductNameFix({
                shopId,
                categoryId: categoryLeafId
            });
            this.isHasNameFix = isNeedRes.data;
        },
        async getFxgProductNameFix(_categoryIds, lables) {
            
            if(!this.isHasNameFix) return;
            let { categoryIds, categoryNames } = this.value;
            lables = lables || categoryNames;
            let categories = _categoryIds || categoryIds;
            if(!categories || !categories.length) {
                return;
            }
            let categoryLeafId = last(categories);
            let shopId = this.shops_getCategoryPropShopId('fxg') || 76398;

            let res = await getFxgProductNameFix({
                shopId,
                categoryLeafId,
                firstCid:  categories[0] || 0,
                firstCidName: lables[0] || '',
                secondCid:  categories[1] || 0,
                secondCidName: lables[1] || '',
                thirdCid:  categories[2] || 0,
                thirdCidName: lables[2] || '',
                selectProperty: this.value.productFormat ? JSON.parse(this.value.productFormat) : {}
            });
            
            this.value.namePrefix = res.data;
        },

        clearFxgProductNameFix() {
            this.value.namePrefix = '';
        },
        async getDayRetrunList() {
            let { categoryIds } = this.value;
            if(!categoryIds || !categoryIds.length) {
                return;
            }
            let categoryLeafId = last(categoryIds);
            let shopId = this.shops_getCategoryPropShopId('fxg');
            const requestParams = {
                shopId,
                categoryId: categoryLeafId
            }
            let res = await getProductUpdateRule(requestParams);
            this.fxgProductUpdateRuleParams = _.cloneDeep(requestParams);
            this.supplyDayReturnList = res.data?.afterSaleRule?.supplyDayReturnRule?.options || [];
            this.threeGuarantees = res.data?.afterSaleRule?.threeGuarantees || {};
            this.homeInstallServiceRule = res.data?.extraRule?.homeInstallServiceRule || {};
            this.isLoadedProductUpdateRule = true;
            this.componentTemplateRule = res.data?.componentTemplateRule || {};
            this.$set(this.rules, 'sizeType', getSizeTypeRules(this))
            this.$set(this.rules, 'sizeTemplateConf', getSizeTemplateConfRules(this))
            this.homeInstallServiceRule.options && this.$set(this.rules, 'homeInstallServiceTemplateId', getHomeInstallServiceTemplateIdRules(this))
            // 三包服务
            if(res.data?.afterSaleRule){
                let threeGuarantees = res.data.afterSaleRule.threeGuarantees || {}
                let optionsMap = threeGuarantees?.options?.reduce((obj, item) => {
                    obj[item.value] = item;
                    return obj;
                }, {});
                this.threeGuarantees = { ...threeGuarantees,optionsMap };
            }
            // 非必填的情况下 切换类目之后原尺码信息给它置空
            if(!this.componentTemplateRule.mustInput && categoryIds.join(',') !== this.detailHasCategory.join(',')) {
                this.value.sizeTemplateList = [];
            }
            this.value.supplyDayReturnSelector = this.value.supplyDayReturnSelector || this.supplyDayReturnList[0]?.value || '';
            // 对发货模式/发货时效交互处理
            const { normalRule = {}, stepRule = {}, shippingOriginRule = {}} = res.data?.fulfillmentRule || {};
            this.shippingOriginRule = shippingOriginRule;
            if (!shippingOriginRule.enable) {
                this.$set(this.value, 'shippingOriginInfo', {});
            } else {
                const shippingOriginInfo = this.value.shippingOriginInfo || {}
                this.$set(this.value, 'shippingOriginInfo', {
                    shippingOriginId: String(shippingOriginInfo.shippingOriginId || ''),
                    shippingOriginType: String(shippingOriginInfo.shippingOriginType || ''),
                });
            }
            let deliveryModes = [
                {label: '现货发货模式', value: 0},
                {label: '全款预售发货模式', value: 1},
                {label: '现货预售混合模式', value: 2}
            ];
             let allSaveDeliveryMode  = [
                {label: '预售结束后', value: 0},
                {label: '支付完成后', value: 1}
            ]
            this.allSaveDeliveryMode = _.cloneDeep(allSaveDeliveryMode)
            this.deliveryModes = _.cloneDeep(deliveryModes)
   
            // 发货模式，需要判断一下当前选中的选项是否还存在
            const hasExist = this.deliveryModes.find(item => {
                return item.value === this.value.presellType;
            })
            if (!hasExist) {
                this.value.presellType = this.deliveryModes.length > 0 ? this.deliveryModes[0].value : '';
            }
            const delayMaps = {
                9999: '当日发',
                1: '次日发',
                2: '48小时内发货',
            };
            const defaultMultiTimes = [
                { timeDesc: '3天内', timeType: 3 },
                { timeDesc: '4天内', timeType: 4 },
                { timeDesc: '5天内', timeType: 5 },
                { timeDesc: '6天内', timeType: 6 },
                { timeDesc: '7天内', timeType: 7 },
                { timeDesc: '8天内', timeType: 8 },
                { timeDesc: '9天内', timeType: 9 },
                { timeDesc: '10天内', timeType: 10 },
                { timeDesc: '15天内', timeType: 15 },
                // { timeDesc: '20天内', timeType: 20 },
                // { timeDesc: '25天内', timeType: 25 },
            ];
            if(this.value.timeSpecList){
                this.value.timeSpecList.forEach(i => {
                    if(['20','25',20,25].includes(i)){
                        defaultMultiTimes.push({ timeDesc: i+'天内', timeType: +i })
                    }
                })
            }
            this.normalDelayOptions = normalRule.delayOptions.map(val => {
                return { value: val, label: delayMaps[val] }
            });
            this.timeSpecLabels = (stepRule.multiTimes || defaultMultiTimes).filter(item => {
                item.timeType = item.timeType + ''
                return true
            });
     
            const { productSpecRule = {}, referencePriceRule = {}, skuRule = {}  } = res.data || {};
            // 参考价
            this.referencePriceRule = _.cloneDeep(referencePriceRule);
            const { isSupport } = referencePriceRule;
            if (!isSupport) {
                // 不支持参考价，需要清空这些参数信息
                this.value.referencePrice = null;
                this.value.referencePriceCertificate = {
                    certificate_type: '',
                    certificate_urls: [],
                };
            }
            // 字节SKU改造
            const { supportPropertyDiy = true } = productSpecRule;
            this.supportPropertyDiy = supportPropertyDiy;
            this.gernerateFxgProductSpec(productSpecRule);
            // SKU分类处理
            this.skuClassificationRule = skuRule?.skuClassificationRule;
            this.skuPictureRule = skuRule?.skuPictureRule || {};
            this.emitSuggestions();
        },
        async gernerateFxgProductSpec(productSpecRule) {
            const { shopId, categoryId } = _.cloneDeep(this.fxgProductUpdateRuleParams);
            const defaultSpecifications = _.cloneDeep(this.originSpecifications)
            const { newSpec, unrenderList = [], needlessSpecList = [] } = await gernerateFxgSpecs(productSpecRule, defaultSpecifications, _.cloneDeep(this.fxgProductUpdateRuleParams));
            this.unrenderSpecList = _.cloneDeep(unrenderList);
            this.specifications = _.cloneDeep(newSpec);
            this.needlessSpecList = _.cloneDeep(needlessSpecList);
            const { requiredSpecDetails = [], maxSpecNumLimit, specSingleLimit } = productSpecRule;
            this.requiredSpecDetails = _.cloneDeep(requiredSpecDetails);
            this.maxSpecNumLimit = maxSpecNumLimit;
            this.specSingleLimit = specSingleLimit;
            // 刷新规格组件重新渲染
            if (this.$refs.fxgSpecification) {
                this.$refs.fxgSpecification.reRenderPage();
            }
            setTimeout(() => {
                this.validPage();
            }, 5000)
            // this.$nextTick(() => {
            // });
        },
        async handleRefundRuleChange(data = []) {
            const subPropertyCategoryList = data.filter(item => {
                return item.hasSubProperty === true;
            });
            this.subPropertyCategoryData = _.cloneDeep(subPropertyCategoryList)
            this.validPage();
        },
        handleCategoryValueChanged({propertyId}) {
            const subPropertyCategoryData = _.cloneDeep(this.subPropertyCategoryData);
            const productFormat = this.value.productFormat ? JSON.parse(this.value.productFormat) : {};
            const promiseList = [];
            subPropertyCategoryData.forEach(item => {
                const { propertyId, cid } = item;
                const matchValue = productFormat[propertyId];
                if (matchValue && matchValue.length > 0) {
                    const cascadeInfo = [];
                    matchValue.forEach(valueItem => {
                        cascadeInfo.push({
                            valueId: valueItem.value,
                            valueName: valueItem.name,
                            cascadeId: 0,
                        })
                    });
                    promiseList.push(fxgGetCascadeValues({
                        ...this.fxgProductUpdateRuleParams,
                        propertyId,
                        cascadeInfo
                    }))
                }
            })
            // 调用接口获取数据
        },
        useGroupImages(data, type) {
            const {mainImages=[], detailImages=[], speImages=[]} = data
            const groupMainImages34 = data?.mainImages34 || []
            let pic = [], description = [], mainImages34 = [];
            if(type === 'add') {
                pic = [...this.value.pic].filter(Boolean)
                mainImages34 = [...this.value.mainImages34].filter(Boolean)
                description = [...this.value.description]
            }
            if(mainImages.length) {
                this.value.pic = [...pic, ...mainImages].slice(0, 5)
            }
            if(groupMainImages34.length) {
                this.value.mainImages34 = [...mainImages34, ...groupMainImages34].slice(0, 5)
            }
            if(detailImages.length) {
                this.value.description = [...description, ...detailImages].slice(0, 50)
            }
            const firstSpec = this.specifications[0];
            if (firstSpec && firstSpec.values && speImages.length) {
                firstSpec.values.forEach(specValue => {
                    // 如果是新增模式且已有图片，则跳过
                    if (type === 'add' && specValue.imageUrl) {
                        return;
                    }
                    
                    // 查找匹配的图片
                    const matchedImage = speImages.find(img => img.name === specValue.value);
                    if (matchedImage) {
                        specValue.imageUrl = matchedImage.imgUrl;
                    }
                });
            }
        },
        getGroupImagesList (list){
            this.showGroupImages = !!list?.length
        },
        editGroupImages(){
            this.changeToBase('openGroupImgs')
        },
        getMultiImages(qualityAttachments) {
            return qualityAttachments.map(item => item.url);
        },
        // handleChange(){
        //     setTimeout(()=>{
        //         let uploadDom = this.$refs.bg_MutiImgUpload.$el.getElementsByClassName('sc-upload')[1];
        //         uploadDom && (uploadDom.style.display='none');
        //     },0)
        // },
        oneClickFill(matchPropValues) {
            const productFormat = JSON.parse(this.value.productFormat);
            this.$set(this, 'initAttrData', parseProductFormat(JSON.stringify({...productFormat, ...JSON.parse(matchPropValues)})));
        },
        clickTemPlateFill(row) {
            const platformCatProp = row.platformCatProp
            let extendId1 = row.extendId1 || '{}'
            const { initAttrData, initMeasureData } =  parseProductFormat(platformCatProp);
            this.value.productFormat = platformCatProp
            try{
                extendId1 = JSON.parse(extendId1)
            }catch(e){
                extendId1 = {}
            }
            this.$set(this, 'initAttrData', initAttrData);
            this.$set(this, 'initMeasureData', initMeasureData);
            this.$set(this.value, 'categoryPropertyPics', extendId1);
        },
        getCategoryProperties(data) {
            this.categoryAttrList = data;
        },
        validateDigitalID(){
            return new Promise((resolve) => {
                if(this.$refs.digitalIDRef){
                    let errMsg = this.$refs.digitalIDRef.method_valid();
                    resolve(errMsg ? false : true)
                }
                resolve(true)
            })
        },
        changePropertyPics(val){
            let newVal = {}
            for(let key in val){
                newVal[key] = {urls:val[key]}
            }
            this.value.categoryPropertyPics = newVal
        },
        // 批量设置sku图
        batchSetSKUImg(url){
            this.skuList.forEach(sku => {
                sku.skuPictureUrl = url
            });
            this.batchSetSKUImgVisible = false
        }
    }
}
</script>

<style lang="scss" scope>
.goodsLimitTable {
    th {
        font-weight: normal;
        font-size: 12px;
        color: #000;
        background: #FAFAFA;
    }
}
.set-ship{
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.shop-title {
  width: 130px;
  margin: 0 16px 0 10px;
  font-size: 12px;
  color: #606266;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.imgs-wrp{
    .el-upload.el-upload--picture-card{
        width: 80px;
        height: 80px;
        line-height: 80px;
        margin-bottom: 10px;
    }
    .el-loading-mask {
        display: none;
    }
}
.presell-end-time {
    .radio-item {
        display: flex;
        align-items: center;
    }
}

.presell-delivery-time {
    display: flex;
    align-items: center;
}

.platform-info-edit-wrp {
  &.is-disabled {
    pointer-events: none;
    opacity: 0.6;
    * {
      pointer-events: none;
    }
  }
}
</style>